import React, { useMemo, useContext } from 'react';
import { useSlate } from 'slate-react';
const selectedTopLevelIdxsContext = React.createContext(null);
export const useSelectedTopLevelIdxs = () => {
    return useContext(selectedTopLevelIdxsContext);
};
export const SelectedTopLevelIdxsProvider = (props) => {
    var _a, _b;
    const editor = useSlate();
    const anchorIdx = (_a = editor.selection) === null || _a === void 0 ? void 0 : _a.anchor.path[0];
    const focusIdx = (_b = editor.selection) === null || _b === void 0 ? void 0 : _b.focus.path[0];
    const idxs = useMemo(() => {
        if (focusIdx == null || anchorIdx == null) {
            return null;
        }
        return [anchorIdx, focusIdx];
    }, [anchorIdx, focusIdx]);
    return (React.createElement(selectedTopLevelIdxsContext.Provider, { value: idxs }, props.children));
};
//# sourceMappingURL=selected-top-level-idxs.js.map